import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';

export const footerLinks = [
    {
        id: 1,
        link: 'Terms and Conditions',
    },
    {
        id: 2,
        link: 'policy',
    },
    {
        id: 3,
        link: 'About us',
    },
    {
        id: 4,
        link: 'help center',
    },
    {
        id: 5,
        link: 'how to shop on sky dome',
    },
    {
        id: 6,
        link: 'report a product',
    },
    {
        id: 7,
        link: 'contact us',
    },
    {
        id: 8,
        link: 'delivery plan',
    },
    {
        id: 9,
        link: 'skydome international',
    },
    {
        id: 10,
        link: 'skydomeinternational@gmail.com',
    },
]

export const footerImg = [
    {
        id: '1a',
        src: "/E-commerce pictures/apple-logo (2).png",
        img: <AppleIcon />
    },
    {
        id: '1b',
        src: "/E-commerce pictures/playstore (2).png",
        img: <AndroidIcon />
    }
]
